import { CodeBlock } from './CodeBlock';

const endpoints = [
  { key: 'send', method: 'POST', path: '/api/v1/send', desc: 'Enviar un mensaje a un numero' },
  { key: 'batch', method: 'POST', path: '/api/v1/send/batch', desc: 'Mismo mensaje a varios numeros' },
  { key: 'status', method: 'GET', path: '/api/v1/status/{message_id}', desc: 'Estado de entrega de un mensaje' },
  { key: 'messages', method: 'GET', path: '/api/v1/messages?limit=50&status=sent', desc: 'Listar mensajes enviados por esta key' },
  { key: 'profiles', method: 'GET', path: '/api/v1/profiles', desc: 'Listar perfiles (cuentas) disponibles para profile_id' },
  { key: 'webhook', method: 'POST', path: '/api/v1/webhook/test', desc: 'Enviar un webhook de prueba a tu URL' },
];

const statuses = [
  ['pending', 'En cola, esperando que el perfil lo tome'],
  ['queued', 'Tomado por la extension / app, enviandose'],
  ['sent', 'Enviado (rcs=true → RCS, rcs=false → SMS)'],
  ['failed', 'Fallo el envio (ver error)'],
  ['skipped_no_rcs', 'Saltado: el numero no tiene RCS y type era "rcs"'],
  ['skipped', 'Saltado (ej. numero en blacklist)'],
];

const sendExamples = (base) => [
  { label: 'curl', code: `curl -X POST ${base}/api/v1/send \\
  -H "X-API-Key: rcs_TU_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "phone": "+5491122334455",
    "message": "Hola {Juan|amigo}, tu pedido esta listo",
    "profile_id": "ID_DEL_PERFIL",
    "type": "rcs",
    "human_typing": true,
    "external_id": "pedido-8812",
    "webhook_url": "https://tu-servidor.com/webhooks/rcs"
  }'` },
  { label: 'JavaScript', code: `const res = await fetch("${base}/api/v1/send", {
  method: "POST",
  headers: { "X-API-Key": "rcs_TU_API_KEY", "Content-Type": "application/json" },
  body: JSON.stringify({
    phone: "+5491122334455",
    message: "Hola {Juan|amigo}, tu pedido esta listo",
    profile_id: "ID_DEL_PERFIL",
    type: "rcs",
    human_typing: true,
    external_id: "pedido-8812",
  }),
});
const data = await res.json();
console.log(data.message_id, data.status); // "pending"` },
  { label: 'Python', code: `import requests

res = requests.post(
    "${base}/api/v1/send",
    headers={"X-API-Key": "rcs_TU_API_KEY"},
    json={
        "phone": "+5491122334455",
        "message": "Hola {Juan|amigo}, tu pedido esta listo",
        "profile_id": "ID_DEL_PERFIL",
        "type": "rcs",
        "human_typing": True,
        "external_id": "pedido-8812",
    },
    timeout=15,
)
data = res.json()
print(data["message_id"], data["status"])  # pending` },
];

const batchExamples = (base) => [
  { label: 'curl', code: `curl -X POST ${base}/api/v1/send/batch \\
  -H "X-API-Key: rcs_TU_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "phones": ["+5491122334455", "+5491133445566"],
    "message": "Promo de {hoy|esta semana}: 20% OFF ---Responde SI para reservar",
    "profile_id": "ID_DEL_PERFIL",
    "type": "both",
    "split_messages": true
  }'` },
  { label: 'JavaScript', code: `await fetch("${base}/api/v1/send/batch", {
  method: "POST",
  headers: { "X-API-Key": "rcs_TU_API_KEY", "Content-Type": "application/json" },
  body: JSON.stringify({
    phones: ["+5491122334455", "+5491133445566"],
    message: "Promo de {hoy|esta semana}: 20% OFF ---Responde SI para reservar",
    profile_id: "ID_DEL_PERFIL",
    type: "both",
    split_messages: true,
  }),
});` },
  { label: 'Python', code: `requests.post(
    "${base}/api/v1/send/batch",
    headers={"X-API-Key": "rcs_TU_API_KEY"},
    json={
        "phones": ["+5491122334455", "+5491133445566"],
        "message": "Promo de {hoy|esta semana}: 20% OFF ---Responde SI para reservar",
        "profile_id": "ID_DEL_PERFIL",
        "type": "both",
        "split_messages": True,
    },
)` },
];

const statusExamples = (base) => [
  { label: 'curl', code: `curl ${base}/api/v1/status/MESSAGE_ID -H "X-API-Key: rcs_TU_API_KEY"

# Respuesta
{
  "message_id": "…", "external_id": "pedido-8812", "phone": "+5491122334455",
  "status": "sent", "rcs": true, "message_type": "rcs",
  "timestamp": "2026-06-01T14:03:11+00:00", "error": null, "webhook_status": "delivered"
}` },
  { label: 'JavaScript', code: `const r = await fetch("${base}/api/v1/status/MESSAGE_ID", { headers: { "X-API-Key": "rcs_TU_API_KEY" } });
const { status, rcs } = await r.json();` },
  { label: 'Python', code: `r = requests.get("${base}/api/v1/status/MESSAGE_ID", headers={"X-API-Key": "rcs_TU_API_KEY"})
print(r.json()["status"])` },
];

const webhookPayload = `POST https://tu-servidor.com/webhooks/rcs
Content-Type: application/json
X-RCS-Event: message.sent            # message.sent | message.failed | message.skipped
X-RCS-Signature: sha256=3f1c…        # HMAC-SHA256 del body con tu webhook secret

{
  "event": "message.sent",
  "message_id": "b0c1…",
  "external_id": "pedido-8812",
  "phone": "+5491122334455",
  "status": "sent",
  "rcs": true,
  "message_type": "rcs",
  "error": null,
  "profile_id": "…",
  "profile_name": "Linea ventas 1",
  "timestamp": "2026-06-01T14:03:11+00:00",
  "created_at": "2026-06-01T14:02:40+00:00"
}`;

const verifyExamples = [
  { label: 'Node.js', code: `import crypto from "crypto";

app.post("/webhooks/rcs", express.raw({ type: "application/json" }), (req, res) => {
  const expected = "sha256=" + crypto.createHmac("sha256", process.env.RCS_WEBHOOK_SECRET)
    .update(req.body).digest("hex");
  if (req.get("X-RCS-Signature") !== expected) return res.sendStatus(401);
  const evt = JSON.parse(req.body);
  // evt.event, evt.status, evt.external_id …
  res.sendStatus(200);
});` },
  { label: 'Python', code: `import hmac, hashlib
from fastapi import FastAPI, Request, HTTPException

app = FastAPI()

@app.post("/webhooks/rcs")
async def rcs_webhook(req: Request):
    body = await req.body()
    expected = "sha256=" + hmac.new(SECRET.encode(), body, hashlib.sha256).hexdigest()
    if req.headers.get("X-RCS-Signature") != expected:
        raise HTTPException(401)
    evt = await req.json()
    return {"ok": True}` },
];

const Section = ({ title, children, testId }) => (
  <section className="bg-zinc-900/40 border border-white/5 rounded-xl p-5 space-y-3" data-testid={testId}>
    <h2 className="text-base font-semibold text-white">{title}</h2>
    {children}
  </section>
);

export const ApiDocsPanel = () => {
  const base = window.location.origin;
  return (
    <div className="space-y-5" data-testid="api-docs-panel">
      <Section title="Autenticacion y base URL" testId="docs-auth">
        <p className="text-xs text-zinc-400 leading-relaxed">
          Todas las llamadas van a <code className="text-cyan-300 font-mono" data-testid="docs-base-url">{base}</code> con el header
          <code className="text-cyan-300 font-mono"> X-API-Key: rcs_…</code>. Crea la key en la pestana <b className="text-zinc-200">API Keys</b>.
          Los mensajes entran con prioridad a la cola del <b className="text-zinc-200">perfil</b> indicado (extension Chrome o App de Escritorio) y respetan el anti-ban (delays, tipeo humano).
        </p>
        <div className="grid gap-1.5">
          {endpoints.map((e) => (
            <div key={e.path} className="flex items-center gap-3 text-xs bg-zinc-950/60 rounded-lg px-3 py-2" data-testid={`docs-endpoint-${e.key}`}>
              <span className={`font-mono font-bold w-12 ${e.method === 'GET' ? 'text-emerald-400' : 'text-amber-400'}`}>{e.method}</span>
              <code className="font-mono text-zinc-200 flex-1">{e.path}</code>
              <span className="text-zinc-500 hidden md:block">{e.desc}</span>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Enviar un mensaje — POST /api/v1/send" testId="docs-send">
        <ul className="text-xs text-zinc-400 grid md:grid-cols-2 gap-x-6 gap-y-1">
          <li><code className="text-zinc-200">phone</code> — numero en formato internacional</li>
          <li><code className="text-zinc-200">message</code> — texto; soporta Spintax <code>{'{a|b|c}'}</code></li>
          <li><code className="text-zinc-200">profile_id</code> — perfil que envia (ver Perfiles o GET /api/v1/profiles)</li>
          <li><code className="text-zinc-200">type</code> — <code>rcs</code> (solo RCS, salta SMS) · <code>sms</code> · <code>both</code></li>
          <li><code className="text-zinc-200">human_typing</code> / <code className="text-zinc-200">typing_speed</code> — tipeo humano (slow | normal | fast)</li>
          <li><code className="text-zinc-200">split_messages</code> — separa el texto por <code>---</code> en varios mensajes</li>
          <li><code className="text-zinc-200">external_id</code> — tu referencia (vuelve en status y webhook)</li>
          <li><code className="text-zinc-200">webhook_url</code> — URL solo para este mensaje (si no, la de la key)</li>
        </ul>
        <CodeBlock tabs={sendExamples(base)} testId="code-send" />
      </Section>

      <Section title="Envio masivo — POST /api/v1/send/batch" testId="docs-batch">
        <CodeBlock tabs={batchExamples(base)} testId="code-batch" />
      </Section>

      <Section title="Consultar estado — GET /api/v1/status/{message_id}" testId="docs-status">
        <CodeBlock tabs={statusExamples(base)} testId="code-status" />
        <div className="grid md:grid-cols-2 gap-1.5 pt-1">
          {statuses.map(([s, d]) => (
            <div key={s} className="flex items-center gap-2 text-xs"><code className="font-mono text-cyan-300 w-32">{s}</code><span className="text-zinc-400">{d}</span></div>
          ))}
        </div>
      </Section>

      <Section title="Webhooks — te avisamos cuando el mensaje cambia de estado" testId="docs-webhooks">
        <p className="text-xs text-zinc-400 leading-relaxed">
          Configura una URL en tu API key (o envia <code className="text-zinc-200">webhook_url</code> por mensaje). Cuando el mensaje pasa a
          <code className="text-emerald-300"> sent</code>, <code className="text-red-300">failed</code> o <code className="text-amber-300">skipped</code> hacemos un POST con reintentos (3 intentos).
          Responde <b className="text-zinc-200">2xx</b> para confirmar. Verifica la firma <code className="text-zinc-200">X-RCS-Signature</code> con el <i>webhook secret</i> de la key.
        </p>
        <CodeBlock code={webhookPayload} language="http" testId="code-webhook-payload" />
        <p className="text-xs text-zinc-400">Verificacion de firma:</p>
        <CodeBlock tabs={verifyExamples} testId="code-webhook-verify" />
      </Section>
    </div>
  );
};
